import React, { useState, useContext } from 'react';
import styled from 'styled-components';
import moment from 'moment';
import { useQuery } from '@apollo/react-hooks';
import colors from '../../styles/colors';
import BaseModal, { ModalList } from '../modals/BaseModal';
import { AppContext } from '../../context/AppContext';
import Loader from '../Loader';
import { GET_SHORT_ORG, LIST_INVOICES } from '../../graphql/queries';
import * as Price from '../../util/Price';

const TableContainer = styled.div`
  box-shadow: 0px 4px 16px rgba(0, 0, 0, 0.05);
  border-radius: 10px;
  height: auto;
  width: 100%;
  background: ${colors.white};
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  min-height: 30vh;
`;

const TableItem = styled.div`
  display: flex;
  font-size: 1.2rem;
  padding: 15px 20px;
  align-items: center;
  justify-content: space-between;
  border-top: 1px solid ${colors.grey6};
  width: 100%;
  box-sizing: border-box;
  cursor: ${(props) => (props.onClick ? 'pointer' : null)};
  transition: all 0.2s;
  &:hover {
    background: ${(props) => (props.onClick ? 'rgba(211, 211, 211, 0.1)' : null)};
  }
`;

const HeadText = styled.div`
  color: ${colors.grey1};
  font-size: 1.2rem;
  font-weight: 500;
`;

const SubText = styled.div`
  color: ${colors.grey1};
  font-size: 1.2rem;
  font-weight: 400;
  margin-top: 3px;
`;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: ${(props) => props.align};
`;

const HeaderText = styled.div`
  font-size: 1.2rem;
  color: ${colors.grey3};
`;

export default function InvoiceTable() {
  const [invoiceModalIsVisible, setInvoiceModalIsVisible] = useState(false);
  const { data, loading } = useQuery(LIST_INVOICES);
  const { data: orgData, loading: orgLoading } = useQuery(GET_SHORT_ORG);
  const { app, setApp } = useContext(AppContext);

  return (
    <>
      <BaseModal
        open={invoiceModalIsVisible}
        modalType={ModalList.InvoiceDetails}
        onClose={setInvoiceModalIsVisible}
        org={orgData?.getCurrentOrganization}
      />
      <TableContainer>
        {loading || orgLoading ? (
          <Loader />
        ) : (
          <>
            <TableItem>
              <HeaderText>INVOICES</HeaderText>
              <HeaderText>AMOUNT</HeaderText>
            </TableItem>
            {data?.listInvoices.map((invoice, index) => {
              invoice.invoiceNumber = `#${data?.listInvoices?.length - index}`;
              return (
                <TableItem
                  key={index}
                  onClick={() => {
                    setApp({ ...app, currentInvoice: invoice });
                    setInvoiceModalIsVisible(true);
                  }}
                >
                  <Container align="flex-start">
                    <HeadText>
                      {`Invoice #${data?.listInvoices?.length - index}`}
                    </HeadText>
                    <SubText>
                      {moment(
                        (invoice.subscriptionCycleEndDate || invoice.paidAt)
                        * 1000,
                      ).format('MM/D/YYYY')}
                    </SubText>
                  </Container>
                  <Container align="flex-end">
                    <HeadText>
                      {`$${Price.output((invoice.totalAmountDue + invoice.additionalAmount), true)}`}
                    </HeadText>
                    <SubText>
                      {invoice.paidAt ? 'Paid' : 'Upcoming payment'}
                    </SubText>
                  </Container>
                </TableItem>
              );
            })}
          </>
        )}
      </TableContainer>
    </>
  );
}
